import { RouterModule } from "@angular/router";
import { NgModule, Component } from "@angular/core";
import { AppMainComponent } from "./shared/component";
import { AppErrorComponent } from "./pages/error/app.error.component";
import { AppAccessdeniedComponent } from "./pages/access/app.accessdenied.component";
//import { AppLoginComponent } from "./pages/auth/login/app.login.component";
import { AppMaintenanceComponent } from "./pages/maintain/app.maintenance";
import { AuthGuard } from "../app/core/guards/auth/auth.guard";
import { AppRoutes } from "../app/shared/lib/api-constant";
import { AppAssociationComponent } from './pages/association/app.association.component';
import { UserSettingsResolver } from "./shared/resolver/user-settings.resolver";
import { UserConfigurationComponent } from "./modules/user/Master-Data-Management/components/user-management/user-configuration/user-configuration/user-configuration.component";
import { AccessGuard } from "./core/guards/access/access.guard";
import { UserGuardGuard } from "./core/guards/user/user.guard";
import { PasswordGuard } from "./core/guards/password/password.guard";
import { ProfileModule } from "./modules/profile/profile.module";
import { EndUserLicenseAgreementComponent } from "./pages/end-user-license-agreement/end-user-license-agreement.component";
import { AuthGuard as Auth0Guard } from '@auth0/auth0-angular';
import { CommonPanelComponent } from "./shared/component/common-panel/common-panel/common-panel.component";
import { Auth0ErrorComponent } from "./pages/auth0-error/auth0-error/auth0-error.component";
import { PageBreakComponent } from "./pages/page-break/page-break/page-break.component";
import { AppNotfoundComponent } from "./pages/not-found/app-notfound/app-notfound.component";
@NgModule({
    imports: [
        RouterModule.forRoot([

            {
                path: '',
                redirectTo: AppRoutes.User.ROOT,
                pathMatch: 'full',


            },
            {
                path: AppRoutes.User.ROOT,
                canActivate: [Auth0Guard,AuthGuard,AccessGuard],
                component: AppMainComponent,
                resolve: {
                    UserSettings: UserSettingsResolver,
                },
                children: [
                    {
                        path: '',
                        canActivate: [UserGuardGuard, AccessGuard, PasswordGuard],
                        children: [
                            {
                                path: '',
                                pathMatch: 'full',
                                redirectTo: AppRoutes.User.HOME,
                            },

                            {
                                
                                path: AppRoutes.User.HOME,
                                canActivate: [AccessGuard],
                                loadChildren: () => import('./modules/user/home/home.module').then(m => m.TntHomeModule)
                            },

                            {
                                path: AppRoutes.User.CONTRACT_AGREEMENT,
                               // canActivate: [AccessGuard],
                                loadChildren: () => import('./modules/user/contract-agreement/contract-agreement.module').then(m => m.ContractAgreementModule)
                            },
                            {
                                path: AppRoutes.User.ALERT_SUBSCRIPTION,
                                canActivate: [AccessGuard],
                                loadChildren: () => import('./modules/user/alert-subscription/alert-subscription.module').then(m => m.AlertSubscriptionModule)
                            },
                            {
                                path: AppRoutes.User.MASTER_DATA_MANAGEMENT,
                                canActivate: [AccessGuard],
                                loadChildren: () => import('./modules/user/Master-Data-Management/master-data-management.module').then(m => m.MasteDataManagementModule)
                            },
                            {
                                path: AppRoutes.User.LIST_VIEW,
                                canActivate: [AccessGuard],
                                loadChildren: () => import('./modules/user/list-view/list-view.module').then(m => m.ListViewModule)
                            },
                            {
                                path: AppRoutes.User.PROFILE,
                                // canActivate: [AccessGuard],
                                loadChildren: () => import('./modules/user/user-configuration/user-configuration.module').then(m =>m.UserConfigurationModule)
                            },
                        ],
                       
                    },
                    {
                        path: AppRoutes.User.MAINTENANCE,
                        component: AppMaintenanceComponent
                    },
                    {
                        path: AppRoutes.User.NOT_ASSOCIATED,
                        component: AppAssociationComponent,
                    }
                ],
            },
            {
                path: AppRoutes.UserAbstract.COMMON_PANEL,
                canActivate: [Auth0Guard, AuthGuard],
                component: CommonPanelComponent,
                children: [
                    {
                        path: '',
                            canActivate: [AccessGuard],
                        loadChildren: () => import('./modules/user/Master-Data-Management/master-data-management.module').then(m => m.MasteDataManagementModule)
                    }
                ]
            },
           // { path: AppRoutes.Auth.LOGIN, component: AppLoginComponent, canActivate: [NoAuthGuard] },
         { path: AppRoutes.AuthAbstract.ERROR, component: AppErrorComponent },
        { path: AppRoutes.AuthAbstract.AUTH0_ERROR, component: Auth0ErrorComponent },
        { path: AppRoutes.AuthAbstract.ACCESS, component: AppAccessdeniedComponent },
        { path: AppRoutes.AuthAbstract.PAGE_BREAK, component: PageBreakComponent },
        { path: AppRoutes.AuthAbstract.MAINTENANCE, component: AppMaintenanceComponent },
        { path: AppRoutes.AuthAbstract.NOT_FOUND, component: AppNotfoundComponent },
        { path: '**', redirectTo: AppRoutes.AuthAbstract.NOT_FOUND },

            // { path: '**', redirectTo: '/notfound' },
        ], {
            // onSameUrlNavigation: 'reload',  // Added for bug 6530 to reload on same URL navigation. 
            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
